import $http from '$http'
import {
    util
} from 'utils';
import {
    Message
} from 'element-ui';
import {
    lg
} from 'utils';


export default {
    methods: {
        getList() {
            this.lists = [];
            this.loading = true; //拼命加载中显示
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            };
            Params = Object.assign({}, Params, this.filterData);
            if (this.$route.name === '重点客户列表(查看)') {
                $http.get("api/Agent/GetMarjorAgentList", Params).then(res => {
                    let {
                        Data,
                        Cnt
                    } = res.data;
                    util.doResult(this, res, () => {
                        this.totalSize = Cnt;
                        this.loading = false; //拼命加载中显示
                        for (var i = 0; i < Data.length; i++) {
                            Data[i].Create_Date = (Data[i].Create_Date).split(" ")[0];
                            if (Data[i].LastFollow == "0") {
                                Data[i].LastFollow = "--"
                            } else {
                                Data[i].LastFollow = (Data[i].LastFollow).split(" ")[0];
                            }
                        }
                        this.lists = Data;
                    })
                });
                return;
            }
            $http.get("api/NewAgent/GetIntentionAgentList", Params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading = false; //拼命加载中显示
                    for (var i = 0; i < Data.length; i++) {
                        Data[i].Create_Date = (Data[i].Create_Date).split(" ")[0];
                        if (Data[i].LastFollow == "0") {
                            Data[i].LastFollow = "--"
                        } else {
                            Data[i].LastFollow = (Data[i].LastFollow).split(" ")[0];
                        }
                    }
                    this.lists = Data;
                });
            });
        },
        getFollowList(options) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: options.pageIndex || 1,
                pageSize: options.pageSize || 10,
                Customer_Id: options.id
            };
            $http.get('api/Follow/GetFollowList', Params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.followUpTotalSize = Cnt;
                    this.followUpList = Data;
                    this.followUpListVisiable = true;
                });
            });
        },
        addFollowUpItem(data) {
            data.Customer_Id = this.currentId;
            $http.post('api/Follow/AddFollow', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.getFollowList({
                        id: this.currentId
                    });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //获取跟进内容详情
        getFollowUpItem(id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: id
            };
            $http.get('api/Follow/GetFollowById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    console.log(JSON.stringify(Data));
                    this.followItem = Data;
                });
            });
        },
        //更新跟进内容详情
        updateFollowUpItem(data) {
            $http.post('api/Follow/UpdateFollow', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.getFollowList({
                        id: this.currentId
                    });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //删除跟进内容
        delFollowUpItem(id) {
            $http.post('api/Follow/DelFollow', {
                Id: id
            }).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.getFollowList({
                        id: this.currentId
                    });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //获取意向客户数据
        getAgent() {
            Message({
                message: '正在获取数据，请稍后...',
                duration: 0
            });
            this.$nextTick(() => {
                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    Id: this.currentcustomerId
                };

                $http.get('api/Agent/GetNewAgentByCustomerId', Params).then(res => {
                    let {
                        Data
                    } = res.data;
                    Message.closeAll();
                    util.doResult(this, res, () => {
                        this.editData = Data;
                        this.modifyDialogVisiable = true;
                    });
                });

            });
        },
        //设为重点或意向客户
        setAgentIntentionOrMajor(IntentionOrMajor) {
            $http.post('api/Agent/SetAgentIntentionOrMajor', {
                Id: this.currentcustomerId,
                IntentionOrMajor: IntentionOrMajor
            }).then(res => {
                util.doResult(this, res, () => {
                    let hint = (IntentionOrMajor === 0) ? '已成功设置为意向客户' : '已成功设置为重点客户';
                    this.$notify({
                        title: '成功',
                        message: hint,
                        type: 'success'
                    });
                    this.getList();
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/ViewCRMAgentManage/services.js